var exports = {
  "kL": "x112a1f60--4abf9e--container",
  "pq": "x112a1f60--4abf9e--info",
  "Kk": "x112a1f60--4abf9e--icon",
};

module.exports = exports;
